export default __webpack_public_path__ + "static/media/@biancacperes.ff534b62.jpg";